import { createContext } from "react";

const LogTypesStruct = {
  value: "",
  label: "",
  hasRestrictions: false,
  channelIds: [],
};

const StaffNoteTypesStruct = {
  value: "",
  label: "",
  hasRestrictions: false,
  channelIds: [],
};

export const LogBookTypesStruct = {
  logTypes: [LogTypesStruct],
  staffNoteTypes: [StaffNoteTypesStruct],
};

const LogBookTypes = createContext({
  logBookTypes: [{ ...LogBookTypesStruct }],
  setLogBookTypes: (logBookTypes) => {},
});

export const LogBookTypesContext = {
  LogBookTypesContext: LogBookTypes,
};
